<template>
  <NxInput
    name="endereco"
    type="text"
    label="Endereço:"
    placeholder="EX: Rua teste"
    :value="localValue"
    @update:value="handleValueUpdate"
    :isDisabled="isDisabled"
  ></NxInput>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputEndereco',
  mixins: [useReactiveModelMixin('value')],
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputEndereco.vue